import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Chart from 'chart.js/auto';
import Itg from './ITG_BLANCO.png'  
import ItgNegro from './ITG-Logo-Negro.png'  
import Scapp from './logo_scapp_blanco.png'  
import ScappNegro from './logo_scapp_negro.png'  


  function normalizeColor(color) {
    if (!color) return [150, 150, 150]; // gris por defecto

    // --- si es un array de colores (Chart.js stacked/gradient)
    if (Array.isArray(color)) {
      return normalizeColor(color[0]);
    }

    // --- si es en formato rgb/rgba
    if (color.startsWith("rgb")) {
      const values = color
        .replace(/^rgba?\(|\s+|\)$/g, "")
        .split(",")
        .map(v => parseFloat(v));
      return values.slice(0, 3); // devuelve [r,g,b]
    }

    // --- si es hex (#rrggbb o #rgb)
    if (color.startsWith("#")) {
      let hex = color.replace("#", "");
      if (hex.length === 3) {
        hex = hex.split("").map(c => c + c).join("");
      }
      const bigint = parseInt(hex, 16);
      return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    }

    return [150, 150, 150]; // fallback gris
  }

  function filterChartDataForPDF(originalData) {
    // Encuentra las posiciones (índices) donde todos los datasets son 0 o null
    const validIndexes = originalData.labels.map((_, i) => {
      return originalData.datasets.some(ds => {
        const v = Array.isArray(ds.data) ? ds.data[i] : undefined;
        return v !== 0 && v !== null && v !== undefined;
      });
    });

    // Filtrar labels y datasets
    return {
      labels: originalData.labels.filter((_, i) => validIndexes[i]),
      datasets: originalData.datasets.map(ds => ({
        ...ds,
        data: ds.data.filter((_, i) => validIndexes[i])
      }))
    };
  }


  const itg = Itg
  const itgNegro = ItgNegro
  const scapp = Scapp
  const scappNegro = ScappNegro
  // const logoITGPath = darkModePDF ? itg : itgNegro;
  // const logoSCAPPPath = darkModePDF ? scapp : scappNegro;  
  // const itg = isElectron() ? `${window.location.origin}/images/ITG_BLANCO.png` : 
  //   process.env.PUBLIC_URL + `/images/ITG_BLANCO.png`
  // const itgNegro = isElectron() ? `${window.location.origin}/images/ITG-Logo-Negro.png` : 
  //   process.env.PUBLIC_URL + `/images/ITG-Logo-Negro.png`
  // const scapp = isElectron() ? `${window.location.origin}/images/logo_scapp_blanco.png` : 
  //   process.env.PUBLIC_URL + `/images/logo_scapp_blanco.png`
  // const scappNegro = isElectron() ? `${window.location.origin}/images/logo_scapp_negro.png` : 
  //   process.env.PUBLIC_URL + `/images/logo_scapp_negro.png`

  // util para cargar imágenes desde /public en base64
  const loadImageBase64 = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = src;
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = reject;
    });
  };

export async function exportToPDFGeneral(chart, opts = {}) {
  const { darkModePDF=false, title, invert, fileName, onProgress } = opts;
  if (!chart) { console.error('exportToPDF: chart null'); return; }

  const MAX_COLUMNS = invert ? 12 : 24;
  const PDF_ORIENTATION = 'landscape';

  try {
    const src = chart;
    if (!src) return;

    // -- Logos
    const logoITGPath = darkModePDF ? itg : itgNegro;
    const logoSCAPPPath = darkModePDF ? scapp : scappNegro;
    const [logoITG, logoSCAPP] = await Promise.all([
      loadImageBase64(logoITGPath),
      loadImageBase64(logoSCAPPPath),
    ]);
    onProgress?.(10);                      // 👈 10% tras cargar assets

    // -- Datos filtrados + chart temporal para PNG
    const srcData = filterChartDataForPDF(src?.config?.data) || { labels: [], datasets: [] };

    const titlesOrder = [];
    (srcData.datasets || []).forEach(ds => {
      const t = (ds.title ?? "Grupo").toString();
      if (!titlesOrder.includes(t)) titlesOrder.push(t);
    });
    const leftTitle  = titlesOrder[0] ?? "Grupo 1";
    const rightTitle = titlesOrder[1] ?? null;

    const datasetsWithAxis = (srcData.datasets || []).map(ds => {
      const t = (ds.title ?? "Grupo").toString();
      const axis = (rightTitle && t === rightTitle) ? "yRight" : "yLeft";
      return {
        ...ds,
        yAxisID: axis,
        backgroundColor: typeof ds.backgroundColor === "string"
          ? ds.backgroundColor.replace(/[\d.]+\)$/g, "1)")
          : ds.backgroundColor
      };
    });

    const tempCanvas = document.createElement("canvas");
    tempCanvas.width = src.canvas.width;
    tempCanvas.height = src.canvas.height;
    const tempCtx = tempCanvas.getContext("2d");

    const axisColor = darkModePDF ? "#ffffff" : "#000000";
    const gridColor = darkModePDF ? "#444444" : "rgba(0,0,0,0.3)";

    const tempChart = new Chart(tempCtx, {
      type: "bar",
      data: { labels: srcData.labels, datasets: datasetsWithAxis },
      options: {
        responsive: false, animation: false,
        interaction: { mode: "index", intersect: false },
        plugins: { legend: { display: false }, tooltip: { enabled: false } },
        scales: {
          x: { title: { display: true, text: invert ? "Jaulas" : "Fechas", color: axisColor, font: { size: 12, weight: "bold" } }, ticks: { color: axisColor }, grid: { color: gridColor } },
          yLeft:  { type: "linear", position: "left",  beginAtZero: true, title: { display: true, text: leftTitle,  color: axisColor, font: { size: 11, weight: "bold" } }, ticks: { color: axisColor },  grid: { color: gridColor, drawOnChartArea: true,  drawTicks: true, drawBorder: true } },
          yRight: { type: "linear", position: "right", beginAtZero: true, title: { display: !!rightTitle, text: rightTitle || "", color: axisColor, font: { size: 11, weight: "bold" } }, ticks: { color: axisColor }, grid: { drawOnChartArea: false, drawTicks: true, drawBorder: true } }
        }
      }
    });

    await new Promise(r => setTimeout(r, 150));
    const imgData = tempCanvas.toDataURL("image/png");
    tempChart.destroy();
    onProgress?.(35);                      // 👈 PNG listo

    // -- PDF base
    const pdf = new jsPDF({ orientation: PDF_ORIENTATION, unit: "pt", format: "a4" });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const pageBackground = darkModePDF ? "#1e1e1e" : "#ffffff";
    const textColor = darkModePDF ? "#ffffff" : "#000000";
    const borderColor = darkModePDF ? "#ffffff" : "#000000";
    const WATERMARK_FIRST_PAGE = false;
    const HEADER_HEIGHT = 60;
    const TABLE_TOP = HEADER_HEIGHT + 20;
    const PAD = 12;

    const paintHeader = () => {
      const itgW = 70, scappW = 120;
      const itgY = (HEADER_HEIGHT - 40) / 2;
      const scappY = (HEADER_HEIGHT - 30) / 2 + 9;
      pdf.addImage(logoITG, "PNG", 40, itgY, itgW, 0);
      pdf.addImage(logoSCAPP, "PNG", pageWidth - scappW - 40, scappY, scappW, 0);
    };
    const paintFullBgFirstPage = () => {
      pdf.setFillColor(pageBackground);
      pdf.rect(0, 0, pageWidth, pageHeight, "F");
      paintHeader();
    };

    // Primera página (gráfico + leyendas)
    paintFullBgFirstPage();
    pdf.setFontSize(16); pdf.setTextColor(textColor); pdf.setFont("helvetica", "bold");
    pdf.text(title, pageWidth / 2, 75, { align: "center" });

    const imgWidth = pageWidth * 0.8;
    const imgHeight = tempCanvas.height * (imgWidth / tempCanvas.width);
    const posX = (pageWidth - imgWidth) / 2;

    // Leyendas (únicas por label)
    const rawDatasets = src.config.data?.datasets || [];
    const seenLabels = new Set();
    const dataLeyendas = rawDatasets.filter(ds => {
      const label = ds.label?.trim?.() ?? "";
      if (!label) return false;
      if (seenLabels.has(label)) return false;
      seenLabels.add(label);
      return true;
    });
    const boxSize = 12, spacingX = 90, spacingY = 22, maxPerRow = 7, marginBetween = 20;
    const count = dataLeyendas.filter(ds => ds.label).length;
    const rows = Math.ceil(count / maxPerRow);
    const legendBoxX = posX - PAD;
    const legendBoxY = 95;
    const containerWidth = imgWidth + PAD * 2;
    const containerHeight = rows * spacingY + 18;

    pdf.setFillColor(darkModePDF ? "#2b2b2b" : "#f5f5f5");
    pdf.setDrawColor(darkModePDF ? "#444" : "#cccccc");
    pdf.roundedRect(legendBoxX, legendBoxY, containerWidth, containerHeight, 6, 6, "FD");
    const legendInnerX = legendBoxX + PAD;
    const legendInnerW = containerWidth - PAD * 2;

    let legendCount = 0;
    dataLeyendas.forEach(ds => {
      if (!ds.label) return;
      const row = Math.floor(legendCount / maxPerRow);
      const col = legendCount % maxPerRow;
      const totalRowItems = Math.min(count - row * maxPerRow, maxPerRow);
      const rowContentWidth = totalRowItems * spacingX;
      const startX = legendInnerX + (legendInnerW - rowContentWidth) / 2;
      const x = startX + col * spacingX;
      const y = legendBoxY + 20 + row * spacingY;
      const [r,g,b] = normalizeColor(ds.backgroundColor);
      pdf.setFillColor(r,g,b); pdf.rect(x, y, boxSize, boxSize, "F");
      pdf.setTextColor(darkModePDF ? "#fff" : "#000"); pdf.setFontSize(10);
      pdf.text(ds.label, x + boxSize + 6, y + boxSize - 2);
      legendCount++;
    });

    const posY = legendBoxY + containerHeight + marginBetween;
    pdf.setFillColor(darkModePDF ? "#2b2b2b" : "#f5f5f5");
    pdf.setDrawColor(darkModePDF ? "#444444" : "#cccccc");
    pdf.roundedRect(posX - PAD, posY - PAD, imgWidth + PAD * 2, imgHeight + PAD * 2, 6, 6, "FD");
    pdf.addImage(imgData, "PNG", posX, posY, imgWidth, imgHeight);

    // ======= Tablas agrupadas por datasets.title =======
    let labels = src.config.data?.labels || [];
    const datasets = src.config.data?.datasets || [];
    labels = [...labels].sort((a,b) => {
      if (!isNaN(a) && !isNaN(b)) return Number(a) - Number(b);
      return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: "base" });
    });

    const CHUNK_DATASET_SIZE = Math.max(1, MAX_COLUMNS - 1);
    const valueAt = (ds, label) => {
      const idx = src.config.data.labels.indexOf(label);
      if (idx === -1) return "";
      const v = Array.isArray(ds.data) ? ds.data[idx] : undefined;
      return v && typeof v === "object" ? v.y : v;
    };

    let currentStartY = PDF_ORIENTATION === "portrait" ? posY + imgHeight + 40 : 60;
    if (PDF_ORIENTATION === "landscape") {
      pdf.addPage();
      paintHeader();
      currentStartY = TABLE_TOP;
    }

    const baseStyles = { fontSize: 8, halign: "center", valign: "middle", lineColor: borderColor, lineWidth: 0.25, textColor: darkModePDF ? "#ffffff" : textColor };
    const headStyles = { fillColor: "#e84e0e", textColor: "#ffffff", halign: "center", lineColor: borderColor, lineWidth: 0.5 };

    // -- Precalcular progreso: cuántos chunks (tablas) habrá en total
    const groupsForCount = new Map();
    for (const ds of datasets) {
      const key = String(ds.title ?? "Sin título");
      if (!groupsForCount.has(key)) groupsForCount.set(key, []);
      groupsForCount.get(key).push(ds);
    }
    const totalChunks =
      [...groupsForCount.values()]
        .map(arr => Math.ceil(arr.length / CHUNK_DATASET_SIZE))
        .reduce((a,b) => a + b, 0);

    let processedChunks = 0;

    // -- AGRUPAR Y PINTAR
    const groups = new Map();
    for (const ds of datasets) {
      const key = (ds.title ?? "Sin título").toString();
      if (!groups.has(key)) groups.set(key, []);
      groups.get(key).push(ds);
    }

    let isFirstTable = true;
    for (const [groupTitle, groupDatasets] of groups.entries()) {
      if (!isFirstTable) {
        pdf.addPage();
        paintHeader();
      }
      isFirstTable = false;

      pdf.setFont("helvetica", "bold"); pdf.setFontSize(14); pdf.setTextColor(textColor);
      pdf.text(groupTitle, pageWidth / 2, TABLE_TOP - 10, { align: "center" });

      for (let start = 0; start < groupDatasets.length; start += CHUNK_DATASET_SIZE) {
        const chunk = groupDatasets.slice(start, start + CHUNK_DATASET_SIZE);

        if (start > 0) {
          pdf.addPage();
          paintHeader();
          pdf.setFont("helvetica", "bold"); pdf.setFontSize(14); pdf.setTextColor(textColor);
          pdf.text(groupTitle, pageWidth / 2, TABLE_TOP - 10, { align: "center" });
        }

        const head = [["Etiqueta", ...chunk.map(ds => ds.label || "")]];
        const body = labels.map(label => [label, ...chunk.map(ds => valueAt(ds, label))]);

        autoTable(pdf, {
          head, body,
          startY: TABLE_TOP,
          theme: "grid",
          styles: baseStyles,
          headStyles,
          margin: { left: 40, right: 40, top: TABLE_TOP, bottom: 40 },
          willDrawPage: () => {
            if (darkModePDF) {
              pdf.setFillColor(pageBackground);
              pdf.rect(0, 0, pageWidth, pageHeight, "F");
            }
            paintHeader();
          },
          didParseCell: (data) => {
            if (darkModePDF && (data.section === "body" || data.section === "foot")) {
              data.cell.styles.fillColor = undefined;
            }
          },
        });

        currentStartY = pdf.lastAutoTable.finalY + 40;

        // 👇 Progreso proporcional de 35% → 95%
        processedChunks++;
        if (onProgress) {
          const pct = 35 + Math.round((processedChunks / Math.max(totalChunks, 1)) * 60);
          onProgress(Math.min(pct, 95));
        }
      }
    }

    // Numeración y marca de agua
    const stampAllPages = (pdf, watermarkImg, darkModePDF, WATERMARK_FIRST_PAGE) => {
      const total = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= total; i++) {
        pdf.setPage(i);
        const w = pdf.internal.pageSize.getWidth();
        const h = pdf.internal.pageSize.getHeight();
        if (i > 1 || WATERMARK_FIRST_PAGE) {
          const wmW = Math.min(500, w * 0.65);
          const wmX = (w - wmW) / 2;
          const wmY = h / 2 - wmW * 0.38;
          pdf.setGState(new pdf.GState({ opacity: 0.08 }));
          pdf.addImage(watermarkImg, "PNG", wmX, wmY, wmW, 0);
          pdf.setGState(new pdf.GState({ opacity: 1 }));
        }
        const label = `${i} / ${total}`;
        pdf.setFont("helvetica", "normal"); pdf.setFontSize(10); pdf.setTextColor(darkModePDF ? "#ffffff" : "#000000");
        pdf.text(label, w - 40, h - 24, { align: "right" });
      }
    };

    stampAllPages(pdf, logoITG, darkModePDF, WATERMARK_FIRST_PAGE);
    onProgress?.(100);                   // 👈 FIN
    pdf.save(fileName);
  } catch (err) {
    console.error("Error en exportToPDF:", err);
    // opcional: notificar fallo como 100 para cerrar barra
    onProgress?.(100);
  }
}

// export async function exportToPDFGeneral (chart, opts = {} ) {
  
//   const { darkModePDF=false, title, invert,fileName, onProgress } = opts;

//   if (!chart) { console.error('exportToPDF: chart null'); return; }

//   const MAX_COLUMNS = invert ? 12 : 24;              // límite por tabla (incluye "Etiqueta")
//   const PDF_ORIENTATION = 'landscape'; // 'portrait' | 'landscape'
  
  
//   try {
//     const src = chart;
//     if (!src) return;

//         // 🔹 Seleccionar logos según darkModePDF
//     const logoITGPath = darkModePDF ? itg : itgNegro;
//     const logoSCAPPPath = darkModePDF ? scapp : scappNegro;

//     // 🔹 Cargar logos primero
//     const [logoITG, logoSCAPP] = await Promise.all([
//       loadImageBase64(logoITGPath),
//       loadImageBase64(logoSCAPPPath),
//     ]);

//   // 1) Datos filtrados
//   const srcData = filterChartDataForPDF(src?.config?.data) || { labels: [], datasets: [] };

//   // 2) Detectar grupos por title (orden estable)
//   const titlesOrder = [];
//   (srcData.datasets || []).forEach(ds => {
//     const t = (ds.title ?? "Grupo").toString();
//     if (!titlesOrder.includes(t)) titlesOrder.push(t);
//   });
//   const leftTitle  = titlesOrder[0] ?? "Grupo 1";
//   const rightTitle = titlesOrder[1] ?? null; // puede ser null si solo hay un grupo

//   // 3) Forzar exactamente DOS ejes: yLeft (grupo 1) y yRight (grupo 2)
//   const datasetsWithAxis = (srcData.datasets || []).map(ds => {
//     const t = (ds.title ?? "Grupo").toString();
//     const axis = (rightTitle && t === rightTitle) ? "yRight" : "yLeft";
//     return {
//       ...ds,
//       yAxisID: axis,
//       // opacidad 1 para el PNG
//       backgroundColor: typeof ds.backgroundColor === "string"
//         ? ds.backgroundColor.replace(/[\d.]+\)$/g, "1)")
//         : ds.backgroundColor
//     };
//   });

//   // 4) Crear chart temporal con SOLO yLeft / yRight
//   const tempCanvas = document.createElement("canvas");
//   tempCanvas.width = src.canvas.width;
//   tempCanvas.height = src.canvas.height;
//   const tempCtx = tempCanvas.getContext("2d");

//   const axisColor = darkModePDF ? "#ffffff" : "#000000";
//   const gridColor = darkModePDF ? "#444444" : "rgba(0,0,0,0.3)";

//   const tempChart = new Chart(tempCtx, {
//     type: "bar",
//     data: {
//       labels: srcData.labels,
//       datasets: datasetsWithAxis
//     },
//     options: {
//       responsive: false,
//       animation: false,
//       interaction: { mode: "index", intersect: false },
//       plugins: {
//         legend: { display: false },
//         tooltip: { enabled: false }
//       },
//       // ⚠️ Importante: no declares "y" ni "y1". Solo estas dos:
//       scales: {
//         x: {
//           position: "bottom",
//           title: {
//             display: true,
//             text: invert ? "Jaulas" : "Fechas",
//             color: axisColor,
//             font: { size: 12, weight: "bold" },
//           },
//           ticks: { color: axisColor },
//           grid: { color: gridColor, drawOnChartArea: true }
//         },
//         yLeft: {
//           type: "linear",
//           position: "left",
//           beginAtZero: true,
//           title: { display: true, text: leftTitle, color: axisColor, font: { size: 11, weight: "bold" } },
//           ticks: { color: axisColor },
//           grid: { color: gridColor, drawOnChartArea: true, drawTicks: true, drawBorder: true }
//         },
//         yRight: {
//           type: "linear",
//           position: "right",
//           beginAtZero: true,
//           // Si no hay segundo grupo, el eje existe pero vacío (no molesta)
//           title: { display: !!rightTitle, text: rightTitle || "", color: axisColor, font: { size: 11, weight: "bold" } },
//           ticks: { color: axisColor },
//           // Sin grilla para no “apagar” el dato del derecho
//           grid: { drawOnChartArea: false, drawTicks: true, drawBorder: true }
//         }
//       }
//     }
//   });


//     await new Promise((r) => setTimeout(r, 200));
//     const imgData = tempCanvas.toDataURL("image/png");

//     // 4) Crear PDF
//     const pdf = new jsPDF({
//       orientation: PDF_ORIENTATION,
//       unit: "pt",
//       format: "a4",
//     });
//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();

//     const pageBackground = darkModePDF ? "#1e1e1e" : "#ffffff";
//     const textColor = darkModePDF ? "#ffffff" : "#000000";
//     const borderColor = darkModePDF ? "#ffffff" : "#000000";

//     // === Header y marca de agua ===
//     // === FLAGS ===
//     const WATERMARK_FIRST_PAGE = false; 

//     const HEADER_HEIGHT = 60;

//     const TABLE_TOP = HEADER_HEIGHT + 20; // 👈 espacio seguro para header en TODAS las páginas con tablas


//     const paintHeader = () => {
//       const itgW = 70;
//       const scappW = 120;
//       const itgY = (HEADER_HEIGHT - 40) / 2;
//       const scappY = (HEADER_HEIGHT - 30) / 2 + 9;

//       pdf.addImage(logoITG, "PNG", 40, itgY, itgW, 0);
//       pdf.addImage(logoSCAPP, "PNG", pageWidth - scappW - 40, scappY, scappW, 0);
//     };

//     // Fondo completo SOLO en la primera página (para no tapar tablas en páginas siguientes)
//     const paintFullBgFirstPage = () => {
//       pdf.setFillColor(pageBackground);
//       pdf.rect(0, 0, pageWidth, pageHeight, "F");
//       paintHeader();
//     };

//     // ======= Página inicial (gráfico) =======
//     paintFullBgFirstPage();

//     pdf.setFontSize(16);
//     pdf.setTextColor(textColor);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(title, pageWidth / 2, 75, { align: "center" });

//     // === Calcular tamaño del gráfico (más bajo, mismo ancho)
//     const imgWidth = pageWidth * 0.8;
//     const imgHeight = tempCanvas.height * (imgWidth / tempCanvas.width)  // bajar altura
//     const posX = (pageWidth - imgWidth) / 2;

//     // === Parámetros compartidos con el contenedor del gráfico
//     const PAD = 12; // mismo padding que usas en el contenedor del gráfico

//     // === Leyendas con contenedor del MISMO ancho que el contenedor del gráfico
//     // const dataLeyendas = src.config.data?.datasets || [];
//     const rawDatasets = src.config.data?.datasets || [];
//     const seenLabels = new Set();
//     const dataLeyendas = rawDatasets.filter(ds => {
//       const label = ds.label?.trim?.() ?? "";
//       if (!label) return false;
//       if (seenLabels.has(label)) return false;
//       seenLabels.add(label);
//       return true;
//     });
//     const boxSize = 12;
//     const spacingX = 90;
//     const spacingY = 22;
//     const maxPerRow = 7;
//     const marginBetween = 20;

//     let count = dataLeyendas.filter((ds) => ds.label).length;
//     let rows = Math.ceil(count / maxPerRow);

//     // ⚠️ IMPORTANTE: usamos el MISMO ancho visual que el "marco" del gráfico
//     const legendBoxX = posX - PAD;                 // mismo X que el marco del gráfico
//     const legendBoxY = 95;
//     const containerWidth = imgWidth + PAD * 2;     // mismo ancho que el marco del gráfico
//     const containerHeight = rows * spacingY + 18;

//     // Dibuja el contenedor de leyendas
//     pdf.setFillColor(darkModePDF ? "#2b2b2b" : "#f5f5f5");
//     pdf.setDrawColor(darkModePDF ? "#444" : "#cccccc");
//     pdf.roundedRect(legendBoxX, legendBoxY, containerWidth, containerHeight, 6, 6, "FD");

//     // Área interior útil (excluye padding visual)
//     const legendInnerX = legendBoxX + PAD;
//     const legendInnerW = containerWidth - PAD * 2;

//     // Distribución centrada por fila dentro del ancho interior
//     let legendCount = 0;
//     dataLeyendas.forEach((ds) => {
//       if (!ds.label) return;

//       const row = Math.floor(legendCount / maxPerRow);
//       const col = legendCount % maxPerRow;

//       const totalRowItems = Math.min(count - row * maxPerRow, maxPerRow);
//       const rowContentWidth = totalRowItems * spacingX;
//       const startX = legendInnerX + (legendInnerW - rowContentWidth) / 2;

//       const x = startX + col * spacingX;
//       const y = legendBoxY + 20 + row * spacingY;

//       const [r, g, b] = normalizeColor(ds.backgroundColor);
//       pdf.setFillColor(r, g, b);
//       pdf.rect(x, y, boxSize, boxSize, "F");

//       pdf.setTextColor(darkModePDF ? "#fff" : "#000");
//       pdf.setFontSize(10);
//       pdf.text(ds.label, x + boxSize + 6, y + boxSize - 2);

//       legendCount++;
//     });

//     // === Gráfico debajo del contenedor de leyendas
//     const posY = legendBoxY + containerHeight + marginBetween;

//     // if (!darkModePDF) {
//     pdf.setFillColor(darkModePDF ? "#2b2b2b" : "#f5f5f5");
//     pdf.setDrawColor(darkModePDF ? "#444444" : "#cccccc");
//     pdf.roundedRect(
//       posX - PAD,
//       posY - PAD,
//       imgWidth + PAD * 2,
//       imgHeight + PAD * 2,
//       6,
//       6,
//       "FD"
//     );

//     // }

//     pdf.addImage(imgData, "PNG", posX, posY, imgWidth, imgHeight);

//     // Overlay en primera página (opcional: dejar la marca de agua también)
//     // addWatermark();
//     // if (WATERMARK_FIRST_PAGE) addWatermark(); // 👈 ahora controlado por flag

//     // ======= Tablas (agrupadas por datasets.title) =======
//     let labels = src.config.data?.labels || [];
//     const datasets = src.config.data?.datasets || [];

//     // Ordena labels de forma natural
//     labels = [...labels].sort((a, b) => {
//       if (!isNaN(a) && !isNaN(b)) return Number(a) - Number(b);
//       return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: "base" });
//     });

//     // Cuántas columnas por tabla (incluye "Etiqueta")
//     const CHUNK_DATASET_SIZE = Math.max(1, MAX_COLUMNS - 1);
//     const valueAt = (ds, label) => {
//       const idx = src.config.data.labels.indexOf(label);
//       if (idx === -1) return "";
//       const v = Array.isArray(ds.data) ? ds.data[idx] : undefined;
//       return v && typeof v === "object" ? v.y : v;
//     };

//     // Pasa las tablas a una nueva página si estamos en landscape
//     let currentStartY = PDF_ORIENTATION === "portrait" ? posY + imgHeight + 40 : 60;
//     if (PDF_ORIENTATION === "landscape") {
//       pdf.addPage();
//       paintHeader(); // solo logos
//       currentStartY = TABLE_TOP;
//     }

//     // Estilos tabla
//     const baseStyles = {
//       fontSize: 8,
//       halign: "center",
//       valign: "middle",
//       lineColor: borderColor,
//       lineWidth: 0.25,
//       textColor: darkModePDF ? "#ffffff" : textColor,
//     };
//     const headStyles = {
//       fillColor: "#e84e0e",
//       textColor: "#ffffff",
//       halign: "center",
//       lineColor: borderColor,
//       lineWidth: 0.5,
//     };
//     const altRow = darkModePDF ? {} : {};

//     // --- 1) AGRUPAR POR datasets.title ---
//     const groups = new Map(); // title -> array<dataset>
//     for (const ds of datasets) {
//       const key = (ds.title ?? "Sin título").toString();
//       if (!groups.has(key)) groups.set(key, []);
//       groups.get(key).push(ds);
//     }

//     // --- 2) RECORRER GRUPOS EN ORDEN ESTABLE ---
//     let isFirstTable = true;
//     for (const [groupTitle, groupDatasets] of groups.entries()) {

//       // Nueva página entre grupos (menos para el primero)
//       if (!isFirstTable) {
//         pdf.addPage();
//         paintHeader();
//       }
//       isFirstTable = false;

//       // TÍTULO DEL GRUPO
//       pdf.setFont("helvetica", "bold");
//       pdf.setFontSize(14);
//       pdf.setTextColor(textColor);
//       pdf.text(groupTitle, pageWidth / 2, TABLE_TOP - 10, { align: "center" });

//       // --- 2a) CHUNKS dentro del grupo si excede MAX_COLUMNS ---
//       for (let start = 0; start < groupDatasets.length; start += CHUNK_DATASET_SIZE) {
//         const chunk = groupDatasets.slice(start, start + CHUNK_DATASET_SIZE);

//         const head = [["Etiqueta", ...chunk.map(ds => ds.label || "")]];
//         const body = labels.map(label => [
//           label,
//           ...chunk.map(ds => valueAt(ds, label)),
//         ]);

//         // Para cada chunk, si no es el primero dentro del grupo, nueva página
//         if (start > 0) {
//           pdf.addPage();
//           paintHeader();
//           // Repetir el título del grupo en cada página de ese grupo
//           pdf.setFont("helvetica", "bold");
//           pdf.setFontSize(14);
//           pdf.setTextColor(textColor);
//           pdf.text(groupTitle, pageWidth / 2, TABLE_TOP - 10, { align: "center" });
//         }

//         autoTable(pdf, {
//           head, body,
//           startY: TABLE_TOP,
//           theme: "grid",
//           styles: baseStyles,
//           headStyles,
//           alternateRowStyles: altRow,
//           margin: { left: 40, right: 40, top: TABLE_TOP, bottom: 40 },

//           // Fondo + header por página de tablas
//           willDrawPage: () => {
//             if (darkModePDF) {
//               pdf.setFillColor(pageBackground);
//               pdf.rect(0, 0, pageWidth, pageHeight, "F");
//             }
//             paintHeader();
//           },

//           didParseCell: (data) => {
//             if (darkModePDF && (data.section === "body" || data.section === "foot")) {
//               data.cell.styles.fillColor = undefined; // sin relleno en dark
//             }
//           },
//         });

//         currentStartY = pdf.lastAutoTable.finalY + 40;
//       }
//     }

//     const stampAllPages = (pdf, watermarkImg, darkModePDF, WATERMARK_FIRST_PAGE) => {
//       const total = pdf.internal.getNumberOfPages();

//       for (let i = 1; i <= total; i++) {
//         pdf.setPage(i);

//         const w = pdf.internal.pageSize.getWidth();
//         const h = pdf.internal.pageSize.getHeight();

//         // --- Marca de agua ---
//         if (i > 1 || WATERMARK_FIRST_PAGE) {
//           const wmW = Math.min(500, w * 0.65);
//           const wmX = (w - wmW) / 2;
//           const wmY = h / 2 - wmW * 0.38;

//           pdf.setGState(new pdf.GState({ opacity: 0.08 }));
//           pdf.addImage(watermarkImg, "PNG", wmX, wmY, wmW, 0);
//           pdf.setGState(new pdf.GState({ opacity: 1 }));
//         }

//         // --- Número de página ---
//         const label = `${i} / ${total}`;
//         pdf.setFont("helvetica", "normal");
//         pdf.setFontSize(10);
//         pdf.setTextColor(darkModePDF ? "#ffffff" : "#000000");

//         pdf.text(label, w - 40, h - 24, { align: "right" });
//       }
//     };


//     stampAllPages(pdf, logoITG, darkModePDF, WATERMARK_FIRST_PAGE);
//     pdf.save(fileName);
//     tempChart.destroy();
//   } catch (err) {
//     console.error("Error en exportToPDF:", err);
//   }
// };


function isElectron() {
  // Renderer process check
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
      return true;
  }

  // Main process check
  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
      return true;
  }

  // Detect the user agent when the `nodeIntegration` is set to false
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
      return true;
  }

  return false;
}
